var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.635,
    height: 29.635,
    viewBox: "0 0 29.635 29.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-close-circle",
    d: "M16.817,2A14.817,14.817,0,1,0,31.635,16.817,14.817,14.817,0,0,0,16.817,2ZM22.31,20.215a1.482,1.482,0,1,1-2.1,2.1l-3.4-3.4-3.4,3.4a1.482,1.482,0,1,1-2.1-2.1l3.4-3.4-3.4-3.4a1.482,1.482,0,1,1,2.1-2.1l3.4,3.4,3.4-3.4a1.482,1.482,0,1,1,2.1,2.1l-3.4,3.4Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoCloseCircle);
export default __webpack_public_path__ + "static/media/so-close-circle.2f3efe4a56c96ad10cd93158bef049c3.svg";
export { ForwardRef as ReactComponent };